export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14266.d360499b.jpg";